import View, { getServerSideProps } from '@/apps/unrealos/views/about';

export { getServerSideProps };
export default View;